var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useState } from "react";
import { createStyles, IconButton, makeStyles } from "@material-ui/core";
import { extractConfig } from "../../../../lib/df";
import { useEndpoints } from "../../NavProvider";
import { FetchStatus } from "./types";
import Modal from "../../../../components/modals/Modal";
import Container from "../../../../components/Container";
import BrandsGrid from "./BrandsGrid";
import { CloseIcon } from "../../../icons";
var useStyles = makeStyles(createStyles({
    modalBackground: {
        backgroundColor: "#f5f5f5",
    },
    container: {
        paddingTop: 16,
        paddingBottom: 32,
    },
    closeBar: {
        textAlign: "right",
    },
    closeIcon: {
        "&:hover": {
            background: "transparent",
        },
    },
    header: {
        display: "flex",
        alignItems: "center",
        height: 33,
        marginBottom: 32,
    },
    title: {
        fontSize: 22,
        fontWeight: "bold",
        lineHeight: "28px",
    },
    logo: {
        height: 24,
        marginLeft: 11.2,
    },
}));
var Brands = function (_a) {
    var open = _a.open, onClose = _a.onClose;
    var styles = useStyles();
    var crossPromoEndpoint = useEndpoints().crossPromo;
    var _b = useState(false), show = _b[0], setShow = _b[1];
    var _c = useState(FetchStatus.Idle), status = _c[0], setStatus = _c[1];
    var _d = useState({
        title: "",
        titleLogoUrl: "",
        products: [],
    }), config = _d[0], setConfig = _d[1];
    var title = config.title, titleLogoUrl = config.titleLogoUrl;
    var handleClose = function () { return setShow(false); };
    var handleExited = useCallback(onClose, [onClose]);
    useEffect(function () {
        setStatus(FetchStatus.Loading);
        fetch(crossPromoEndpoint)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            var crossPromoConfig = extractConfig("cross_promotion", data);
            setConfig(function (config) { return (__assign(__assign({}, config), crossPromoConfig)); });
            setStatus(FetchStatus.Success);
        })
            .catch(function (e) {
            console.error("Failed to load brands", e === null || e === void 0 ? void 0 : e.message);
            setStatus(FetchStatus.Failed);
        });
    }, [crossPromoEndpoint]);
    useEffect(function () {
        if (open)
            setShow(true);
    }, [open]);
    return (React.createElement(Modal, { id: "acm-header__brands", open: show, onClose: handleClose, onExited: handleExited, fullScreen: true, classes: { paper: styles.modalBackground } },
        React.createElement(Container, { className: styles.container },
            React.createElement("div", { className: styles.closeBar },
                React.createElement(IconButton, { className: styles.closeIcon, edge: "end", disableRipple: true, onClick: handleClose },
                    React.createElement(CloseIcon, null))),
            React.createElement("header", { className: styles.header },
                React.createElement("h1", { className: styles.title }, title),
                React.createElement("img", { className: styles.logo, src: titleLogoUrl, alt: title, width: "56.4", height: "24" })),
            status === FetchStatus.Failed ? (React.createElement("p", null, "Something went wrong, please try again later.")) : status === FetchStatus.Success ? (React.createElement(BrandsGrid, { products: config.products })) : null)));
};
export default Brands;
